import { useEffect } from "react";
import { ROUNDS } from "@/data/rounds";
import { ROSTER } from "@/data/roster";
import { rosterFromRounds } from "@/lib/scoring";
import { displayName } from "@/data/nicknames";

export const RosterSection = () => {
  useEffect(() => {
    rosterFromRounds(ROUNDS)
      .filter((name) => !ROSTER.includes(name))
      .forEach((name) =>
        console.warn(
          `Cypress Boys data error: "${name}" appears in rounds.js but is missing from roster.js — a typo may have created a phantom player. Fix the spelling so both files match.`
        )
      );
  }, []);

  const lastName = (name) => name.split(" ").slice(-1)[0];
  const members = [...ROSTER].sort((a, b) => {
    const byLast = lastName(a).localeCompare(lastName(b));
    return byLast !== 0 ? byLast : a.localeCompare(b);
  });

  return (
    <div className="mx-auto max-w-5xl px-4 py-8 sm:px-6 sm:py-10">
      <p className="text-xs font-bold uppercase tracking-[0.3em] text-cypress-gold">The Cypress Boys</p>
      <h2 className="mt-1 text-2xl font-bold tracking-tight sm:text-3xl">The whole crew.</h2>
      <div className="mt-6 grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4" data-testid="roster-grid">
        {members.map((name, i) => (
          <div
            key={name}
            data-testid={`roster-card-${i + 1}`}
            className="rounded-lg border border-cypress-gold/15 bg-cypress-green/40 px-4 py-3"
          >
            <p className="font-semibold tracking-tight">{displayName(name)}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
